export enum SettingsType {
  INTERIOR_MATERIAL_SETTINGS = "INTERIOR_MATERIAL_SETTINGS",
  EXTERIOR_MATERIAL_SETTINGS = "EXTERIOR_MATERIAL_SETTINGS",
  EXTERIOR_PROP_SETTINGS = "EXTERIOR_PROP_SETTINGS",
  INTERIOR_PROP_SETTINGS = "INTERIOR_PROP_SETTINGS",
  ROOF_SETTINGS = "ROOF_SETTINGS",
  DORMER_SETTINGS = "DORMER_SETTINGS",
  DOOR_SETTINGS = "DOOR_SETTINGS",
  WINDOW_SETTINGS = "WINDOW_SETTINGS",
  PORCH_SETTINGS = "PORCH_SETTINGS",
  REAR_PORCH_SETTINGS = "REAR_PORCH_SETTINGS",
  PLAN_SETTINGS = "PLAN_SETTINGS",
  MASTER_PLAN_SETTINGS = "MASTER_PLAN_SETTINGS",
  SCHEDULE_SETTINGS = "SCHEDULE_SETTINGS",
  KEY_MEASURES_SETTINGS = "KEY_MEASURES_SETTINGS",
  FOUNDATION_SETTINGS = "FOUNDATION_SETTINGS",
  WAINSCOTING_SETTINGS = "WAINSCOTING_SETTINGS",
  WALL_FRAMING_SETTINGS = "WALL_FRAMING_SETTINGS",
  ROOF_FRAMING_SETTINGS = "ROOF_FRAMING_SETTINGS",
  WINDOW_FRAMING_SETTINGS = "WINDOW_FRAMING_SETTINGS",
  WINDOW_WRAPPING_SETTINGS = "WINDOW_WRAPPING_SETTINGS",
  DOOR_FRAMING_SETTINGS = "DOOR_FRAMING_SETTINGS",
  DOOR_WRAPPING_SETTINGS = "DOOR_WRAPPING_SETTINGS",
  AWNING_SETTINGS = "AWNING_SETTINGS",
  WALL_SETTINGS = "WALL_SETTINGS",
  WALL_CATALOG_SETTINGS = "WALL_CATALOG_SETTINGS",
  EXTERIOR_DOOR_CASING_SETTINGS = "EXTERIOR_DOOR_CASING_SETTINGS",
  INTERIOR_DOOR_CASING_SETTINGS = "INTERIOR_DOOR_CASING_SETTINGS",
  GARAGE_SETTINGS = "GARAGE_SETTINGS",
  EXTERIOR_TRIM_SETTINGS = "EXTERIOR_TRIM_SETTINGS",
  INTERIOR_TRIM_SETTINGS = "INTERIOR_TRIM_SETTINGS",
  STRUCTURE_SETTINGS = "STRUCTURE_SETTINGS",
  ELECTRICAL_SETTINGS = "ELECTRICAL_SETTINGS",
  WINDOW_MULLION_SETTINGS = "WINDOW_MULLION_SETTINGS",
  WINDOW_SHUTTER_SETTINGS = "WINDOW_SHUTTER_SETTINGS",
  EXTERIOR_WINDOW_CASING_SETTINGS = "EXTERIOR_WINDOW_CASING_SETTINGS",
  VIEW_NOTE_SETTINGS = "VIEW_NOTE_SETTINGS",
  DRAWING_CATALOG_SETTINGS = "DRAWING_CATALOG_SETTINGS",
  CASEWORK_CATALOG_SETTINGS = "CASEWORK_CATALOG_SETTINGS",
  CASEWORK_SETTINGS = "CASEWORK_SETTINGS",
  DOOR_CATALOG_SETTINGS = "DOOR_CATALOG_SETTINGS",
  WINDOW_CATALOG_SETTINGS = "WINDOW_CATALOG_SETTINGS",
  COLUMN_CATALOG_SETTINGS = "COLUMN_CATALOG_SETTINGS",
  PROFILE_CATALOG_SETTINGS = "PROFILE_CATALOG_SETTINGS",
  STAIR_CATALOG_SETTINGS = "STAIR_CATALOG_SETTINGS",
  RAILING_CATALOG_SETTINGS = "RAILING_CATALOG_SETTINGS",
  ELECTRICAL_ITEM_CATALOG_SETTINGS = "ELECTRICAL_ITEM_CATALOG_SETTINGS",
  FLOOR_SETTINGS = "FLOOR_SETTINGS",
  WINDOW_MATERIAL_SETTINGS = "WINDOW_MATERIAL_SETTINGS",
  INTERIOR_WINDOW_CASING_SETTINGS = "INTERIOR_WINDOW_CASING_SETTINGS",
  HEADER_FRAMING_SETTINGS = "HEADER_FRAMING_SETTINGS",
}

export const BUILT_IN_SETTINGS_TYPE_PREFIX = "Built-In";

export const builtInSettingTypes = [
  SettingsType.PLAN_SETTINGS,
  SettingsType.SCHEDULE_SETTINGS,
  SettingsType.MASTER_PLAN_SETTINGS,
] satisfies readonly SettingsType[];
